/* eslint-disable */
/*
 * Copyright © 2020-2025 Ocean Galaxy Inc. All Rights Reserved.
 * @Description: 信用报告相关请求
 * @LastEditors: yingongjing
 * @LastEditTime: 2026-01-12 21:30:00
 */
import fetchHelper from '../utils/fetchHelper'
import { captureFetchException } from '../utils/sentryUtils'

/**
 * 生成 POST 请求的 redux-thunk action
 * @param {string} path API 路径
 */
const createPostAction = (path) => (data) => (dispatch, getState) => {
  const config = {
    url: __API_SERVER_HOST__ + path,
    arguments: {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    }
  }

  return fetchHelper(dispatch, getState, config)
    .then((result) => {
      return Promise.resolve(result)
    })
    .catch((err) => {
      captureFetchException(err, config)
      return Promise.reject(err || null)
    })
}

/**
 * 获取脱敏姓名
 * @param {Object} data - 请求参数
 * @param {string} data.phone - 手机号
 */
export const fetchMaskedName = createPostAction('/web/credit/v2/masked_name')

/**
 * 获取用户信用报告数据
 * @param {Object} data - 请求参数
 * @param {string} data.phone - 手机号
 * @param {string} data.username - 完整姓名
 * @param {string} data.userID - 用户ID（看自己就传自己）
 * @param {boolean} data.isSelf - 是否为查看自己的信用分
 * @param {number} data.os - 操作系统，1：ios，2：android
 * @param {number} data.versionCode - 版本号
 */
export const fetchCreditReport = createPostAction('/web/credit/v2/info')
